import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Box } from "@mui/material";
import KeyboardArrowRightOutlinedIcon from "@mui/icons-material/KeyboardArrowRightOutlined";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import "../../assets/swap.scss";
import Text from "../text/Text";
import { btc, sats, swap, swapCurrencyMsg } from "../messages";
import { showAmount } from "../constants";
import { walletIconBlue } from "../images";
import CommonDrawer from "../drawer/CommonDrawer";

function SwapCurrencyDrawer({
  isFromBrowser,
  isOpenModal,
  setIsOpenModal,
  balances,
  setSelectedAssetForSwap,
  setIsOpenSwapModal,
  setSelectedAssetForSwapBalance,
  supportedSwaps,
}) {
  const [otherAssets, setOtherAssets] = useState([]);

  const { taprootAsset, accountAssets, showBtcAmount } = useSelector(
    (state) => state.common
  );

  const { uuid: currency } = { ...taprootAsset };
  const swapCurrency = currency === sats && showBtcAmount ? btc : currency;

  const textSize = isFromBrowser ? 16 : 14;

  useEffect(() => {
    if (accountAssets.length) {
      const enabledCurrency = accountAssets.filter((asset) =>
        supportedSwaps.some(
          (swap) => swap.target_currency_swap_out === asset.uuid
        )
      );
      setOtherAssets(enabledCurrency);
    }
  }, [accountAssets]);

  const handleClose = () => {
    setIsOpenModal(false);
  };

  const handleSelectAsset = (asset, balance) => {
    setSelectedAssetForSwap(asset);
    setSelectedAssetForSwapBalance(balance);
    setIsOpenSwapModal(true);
    setIsOpenModal(false);
  };

  const renderModalContent = () => {
    return (
      <Box>
        <Text
          className="grey-text"
          size={textSize}
          font="regular"
          sx={{ margin: "0px 0 15px" }}
        >
          {swapCurrencyMsg(swapCurrency)}
        </Text>
        {otherAssets.map((asset) => {
          const balance = balances?.find(
            (bal) => bal.target_currency === asset.uuid
          )?.amount;

          const balanceVal =
            !showBtcAmount && asset?.uuid === sats
              ? Math.floor(balance)
              : balance;

          const convertedBalance = showAmount({
            amount: balanceVal || 0,
            currency: asset?.uuid,
            showCommaSeparated: true,
            appendCurrency: true,
            targetedCurrency:
              showBtcAmount && asset?.uuid === sats ? "BTC" : asset?.uuid,
          });

          return (
            <Box
              className="currency-box"
              key={asset.uuid}
              id={asset.uuid}
              onClick={() => handleSelectAsset(asset, balance)}
            >
              <Box display="flex" gap="10px" alignItems="center">
                <img
                  src={walletIconBlue}
                  height={20}
                  width={20}
                  alt="wallet icon"
                />
                <Text size={textSize} font="semibold" className="default-text">
                  {asset.name}
                </Text>
              </Box>
              <Box display="flex">
                <Text size={textSize} font="semibold" className="blue-text">
                  {convertedBalance}
                </Text>
                <KeyboardArrowRightOutlinedIcon
                  sx={{
                    height: "24px",
                    width: "24px",
                    color: "#848B9E",
                    marginLeft: "8px",
                  }}
                />
              </Box>
            </Box>
          );
        })}
      </Box>
    );
  };

  return (
    <CommonDrawer
      anchor="bottom"
      onClose={handleClose}
      className="swap-selection-mode-drawer"
      open={isOpenModal}
    >
      <Box className="swap-selection-drawer">
        <Box className="drawer-header">
          <ArrowBackIcon
            onClick={() => {
              handleClose();
            }}
          ></ArrowBackIcon>
          <Text className="default-text" size={18} font="semibold">
            {`${swap} ${swapCurrency}`}
          </Text>
        </Box>
        <Box className="drawer-content">{renderModalContent()}</Box>
      </Box>
    </CommonDrawer>
  );
}

export default SwapCurrencyDrawer;
